import React, { useState } from 'react';
import '../css/footer.css';

export default function Footer() {


    const [email, setEmail] = useState('');
const [message, setMessage] = useState('');

const handleNewsletterSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("email", email);

    fetch("https://script.google.com/macros/s/AKfycbwPUgyvTL-zzKrENOSq0_X-c862WPsDeWKyh6Wv3-ZO3TP6mBb34pAvDs3Zfi5G9foA0g/exec", {
        method: "POST",
        body: formData
    })
    .then(() => {
        setMessage("✔ Subscribed Successfully!");
        setEmail('');
    })
    .catch(() => {
        setMessage("❌ Subscription Failed");
    });
};





    return (
        < div className="footer" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-contact">
                            <h2>Contact Us</h2>
                            <a href="https://maps.app.goo.gl/rcoJgUGQ9RZ378c87" target="_blank" rel="noopener noreferrer"><p><i className="fa fa-map-marker-alt"></i>Markundi Gurma, Sonebhadra U.P. 231209</p></a>
                            <a href="tel:+91-6388884300"><p><i className="fa fa-phone"></i>+91-6388884300</p></a>
                            <a href="mailto:contact@udaansewatrust.com"><p><i className="fa fa-envelope"></i>contact@udaansewatrust.com</p></a>
                            
                            <div className="footer-social">
                               
                                <a className="btn btn-custom" 
       href="https://x.com/Udaansewatrust" 
       target="_blank" 
       rel="noopener noreferrer">
        <i className="fab fa-x-twitter"></i>
    </a>

    <a className="btn btn-custom" 
       href="https://www.facebook.com/udaansewatrust" 
       target="_blank" 
       rel="noopener noreferrer">
        <i className="fab fa-facebook-f"></i>
    </a>

    <a className="btn btn-custom" 
       href="https://www.instagram.com/udaansewatrust" 
       target="_blank" 
       rel="noopener noreferrer">
        <i className="fab fa-instagram"></i>
    </a>

    <a className="btn btn-custom" 
       href="https://www.youtube.com/@udaansewatrust" 
       target="_blank" 
       rel="noopener noreferrer">
        <i className="fab fa-youtube"></i>
    </a>

    <a className="btn btn-custom" 
       href="https://www.linkedin.com/company/udaansewatrust/" 
       target="_blank" 
       rel="noopener noreferrer">
        <i className="fab fa-linkedin-in"></i>
    </a>
                               
                                </div>
                            <div className="footer-map mt-3">
    <iframe
        title="Office Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3627.184642026168!2d83.04454100016335!3d24.617320243939545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398efbede978dfc7%3A0xb1735400469e22ea!2sMarkundi%20gurma%20sonbhadra!5e0!3m2!1sen!2sin!4v1771088260426!5m2!1sen!2sin"
        width="100%"
        height="180"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
</div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-link">
                            <h2>Popular Links</h2>
                            <a href="/about">About Us</a>
                            <a href="/contact">Contact Us</a>
                            <a href="/event">Popular Causes</a>
                            <a href="/event">Upcoming Events</a>
                            <a href="/donate">Donate Now</a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-link">
                            <h2>Useful Links</h2>
                            <a href="#">Terms of use</a>
                            <a href="#">Privacy policy</a>
                            <a href="#">Cookies</a>
                            <a href="#">Help</a>
                            <a href="#">FAQs</a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-newsletter">
    <h2>Newsletter</h2>
    <form onSubmit={handleNewsletterSubmit}>
        <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-control"
            placeholder="Email goes here"
            autoComplete="email"
            required
        />
        <button className="btn btn-custom">Submit</button>
        <h6>Don't worry, we don't spam!</h6>
        <p className="text-success">{message}</p>
    </form>
</div>

                    </div>
                </div>
            </div>
            <div className="container copyright">
                <div className="row">
                    <div className="col-md-6">
                        <p>&copy; <a href="#">UDAAN SEWA TRUST</a> | 2026, All Right Reserved.</p>
                    </div>
                    <div className="col-md-6">
                        <p>Designed By <a href="">Udaan Sewa Trust</a></p>
                    </div>
                </div>
            </div>
        </ div>
    );
}